import React from 'react';
import { useSEO } from '../../../hooks/useSEO';
import { MW_CONTENT as C } from './content';
import WhatsAppCTA from '../SoftwareForDistributors/components/WhatsAppCTA';
import SectionPain from '../SoftwareForDistributors/components/SectionPain';
import SectionSolution from '../SoftwareForDistributors/components/SectionSolution';
import SectionBenefits from '../SoftwareForDistributors/components/SectionBenefits';
import SectionDifferentials from '../SoftwareForDistributors/components/SectionDifferentials';
import SectionFAQ from '../SoftwareForDistributors/components/SectionFAQ';
import './MechanicWorkshopLanding.scss';

const MechanicWorkshopLanding: React.FC = () => {
  useSEO({
    title: C.seo.title,
    description: C.seo.description,
    canonical: '/sistema-para-oficina-mecanica',
    jsonLd: {
      '@context': 'https://schema.org',
      '@type': 'SoftwareApplication',
      name: '77Gestão — Sistema para Oficina Mecânica',
      applicationCategory: 'BusinessApplication',
      operatingSystem: 'Web',
      url: 'https://77gestao.com.br/sistema-para-oficina-mecanica',
      description: C.seo.description,
    },
  });

  return (
    <div className="mechanic-workshop-landing">
      {/* ── Hero ─────────────────────────────────────────────────────── */}
      <section className="lp-hero" aria-labelledby="mw-hero-title">
        <div className="lp-container">
          <span className="lp-kicker">{C.hero.kicker}</span>
          <div className="lp-hero-title-wrapper">
            <h1 className="lp-title" id="mw-hero-title">{C.hero.title}</h1>
            <div className="lp-hero-icon">
              <i className="fa-solid fa-car-side" aria-hidden="true" />
            </div>
          </div>
          <p className="lp-subtitle">{C.hero.subtitle}</p>
          <WhatsAppCTA message={C.hero.ctaMessage} id="cta-hero">
            {C.hero.cta}
          </WhatsAppCTA>
          <p className="lp-meta">{C.hero.urgency}</p>
        </div>
      </section>

      {/* ── Stats strip ──────────────────────────────────────────────── */}
      <div className="mw-stats-strip" aria-hidden="true">
        <div className="lp-container">
          {C.statsStrip.map((s, i) => (
            <div className="mw-stat" key={i}>
              <i className={s.icon} />
              <span className="mw-stat__number">{s.number}</span>
              <span className="mw-stat__label">{s.label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* ── Pain ─────────────────────────────────────────────────────── */}
      <SectionPain {...C.pain} />

      {/* ── Mid CTA ──────────────────────────────────────────────────── */}
      <div className="mw-mid-cta">
        <div className="lp-container">
          <p>{C.midCta.text}</p>
          <WhatsAppCTA message={C.midCta.ctaMessage} id="cta-mid">
            {C.midCta.cta}
          </WhatsAppCTA>
        </div>
      </div>

      {/* ── Solution ─────────────────────────────────────────────────── */}
      <SectionSolution {...C.solution} />

      {/* ── Proof ────────────────────────────────────────────────────── */}
      <section className="lp-section lp-section--proof" aria-labelledby="mw-proof-title">
        <div className="lp-container">
          <h2 id="mw-proof-title">{C.proof.title}</h2>
          <p className="lp-intro">{C.proof.intro}</p>

          <div className="mw-proof-stats">
            {C.proof.stats.map((s, i) => (
              <div className="mw-proof-stat" key={i}>
                <span className="mw-proof-stat__number">{s.number}</span>
                <span className="mw-proof-stat__label">{s.label}</span>
              </div>
            ))}
          </div>

          <div className="lp-proof-box">
            {C.proof.paragraphs.map((p, i) => <p key={i}>{p}</p>)}
            <p className="lp-proof-highlight">
              <i className="fa-solid fa-check-circle" aria-hidden="true" />
              {C.proof.highlight}
            </p>
          </div>

          <div className="lp-section-cta">
            <WhatsAppCTA message={C.proof.ctaMessage} id="cta-proof">
              {C.proof.cta}
            </WhatsAppCTA>
          </div>
        </div>
      </section>

      {/* ── Benefits ─────────────────────────────────────────────────── */}
      <SectionBenefits {...C.benefits} />

      {/* ── Differentials ────────────────────────────────────────────── */}
      <SectionDifferentials
        {...C.differentials}
        cta={{ text: 'Falar com a equipe', message: C.hero.ctaMessage }}
      />

      {/* ── FAQ ──────────────────────────────────────────────────────── */}
      <SectionFAQ {...C.faq} />

      {/* ── CTA Final ────────────────────────────────────────────────── */}
      <section className="lp-cta-final" id="schedule-demo" aria-labelledby="mw-cta-final-title">
        <div className="lp-container">
          <h2 id="mw-cta-final-title">{C.ctaFinal.title}</h2>
          <p>{C.ctaFinal.subtitle}</p>
          <WhatsAppCTA message={C.ctaFinal.ctaMessage} className="lp-btn lp-btn--final" id="cta-final">
            {C.ctaFinal.cta}
          </WhatsAppCTA>
        </div>
      </section>
    </div>
  );
};

export default MechanicWorkshopLanding;
